import { createGlobalStyle } from 'styled-components';
import 'bootstrap/dist/css/bootstrap.css';
import { colors } from './shared/colors';

const GlobalStyle = createGlobalStyle`

  html {
    position: relative;
    height: 100% ;
    width: 100% ;
    font-size: 16px;
    font-family: 'Segoe UI', 'Noto Sans', sans-serif;
    font-weight:400;
    color:${colors.magellanBlack};
  }
  
  body {
    height: 100%;
    width: 100%;
    font-size: 1em;
    font-family: 'Segoe UI', 'Noto Sans', sans-serif;
  }

  h1 {
    color: ${colors.dhcsBlue};
    font-size: 20pt;
    font-weight: 700;
  }

  h2 {
    color: ${colors.dhcsTeal};
    font-size: 18pt;
    font-weight: 700;
  }

  h3 {
    color: ${colors.dhcsTeal};
    font-size: 16pt;
    font-weight: 600;
  }

  h4 {
    color: ${colors.dhcsTeal};
    font-size: 14pt;
    font-weight: 600;
  }

  h5 {
    color: ${colors.dhcsTeal};
    font-size: 13pt;
    font-weight: 500;
  }
  
  main {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  
  p {
    color: ${colors.magellanBlack};
    font-size: 1em;
    font-weight: 400;
  }

  a {
    color: ${colors.dhcsLinkBlue};
    text-decoration: underline;
  }
  
  a:hover {
    color: ${colors.dhcsTeal};
    textDecoration: underline;
  }
 
  .initialLoadingScreen {
    margin-top: 40vh;
    margin-left: 40vw;
  }

`;

export default GlobalStyle;